module.exports = __webpack_public_path__ + "img/lg_ring_y_i_null_null@3x.6aacbf5d.png";